import Resource from './Resource.js';
import moment from 'moment';

var colpoResource = new Resource({
		baseUrl: '/api/colpo',
        dates: ['opens_at', 'closes_at'],
        name: 'ColpoResourse'
    })

colpoResource.participants = {
	all: function (substudyId) {
		return axios.get('/api/colpo/participants').then(function (response) {
			// var parts = Object.values(response.data).map(function (i) {
			var parts = Object.values(response.data).map(function (i) {
				i.last_reviewed_at = (i.last_reviewed_at) ? moment(i.last_reviewed_at, 'YYYY-MM-DD') : null;
				if (i.last_exam) {
					i.last_exam.starts_at = (i.last_exam.starts_at) ? moment(i.last_exam.starts_at, 'YYYY-MM-DD HH:mm:ss') : null;
				}
				if (i.upcoming_task) {
					i.upcoming_task.date_due = (i.upcoming_task.date_due) ? moment(i.upcoming_task.date_due, 'YYYY-MM-DD HH:mm:ss') : null;
				}
				return i;
			});
			return response;
		});
	},
	find: function (id) {
		return axios.get('/api/colpo/participants/'+id)
			.then(function (response) {
				response.data.last_reviewed_at = (response.data.last_reviewed_at) ? moment(response.data.last_reviewed_at, 'YYYY-MM-DD') : null;
				if (response.data.last_exam) {
					response.data.last_exam.starts_at = (response.data.last_exam.starts_at) ? moment(response.data.last_exam.starts_at, 'YYYY-MM-DD HH:mm:ss') : null;
				}
				if (response.data.upcoming_task) {
					response.data.upcoming_task.date_due = (response.data.upcoming_task.date_due) ? moment(response.data.upcoming_task.date_due, 'YYYY-MM-DD HH:mm:ss') : null;
				}
				return response;
			});
	},
	updateLastReviewed: function (participant) {
		return axios.put('/api/participants/'+participant.id, {
			'colpo_review_date': moment().format('YYYY-MM-DD')
		}).then(function (response) {
			return this.find(participant.id)
		}.bind(this));
	},
	cancelUpcomingTask: function (participant) {
		return axios.put('/api/tasks/'+participant.upcoming_task.id, {
			task_status_id: 5
		}).then(function (response) {
			return this.find(participant.id);
		}.bind(this)).catch(function (error) {
			alert('There was a problem canceling the upcoming task');
		});
	},
	triggerColpoTask: function (participant, visitWindow) {
		return axios.post('/api/tasks', 
			{
				'task_type_id': 5,
				'task_status_id': 1,
				'owner_id': participant.id,
				'owner_type': 'App\\Models\\Participant',
				'date_due': moment(visitWindow.opens_at).format('YYYY-MM-DD'),
				'data': {visit_window_id: visitWindow.id}
			}
		).then(function (response) {
			return this.find(participant.id);
		}.bind(this))
		.catch(function (error) {
			return 
		})
	}

}

export default colpoResource;